import { IBookingOnlineOldCustomer } from 'pages/reservationBookingOnlineV2/pages/StepConfirmationOfReservationDetail/types';
import {
  IAvailableReservationBooking, ICMInfo, IHeadQuarterData, IReservationSearchBookingOnline, IStoreSettingDetail,
} from 'pages/reservationBookingOnlineV2/pages/StepDateAndTimeVisitSelection/types';
import {
  TDesiredCareParam, TDesiredCourseParam, TDesiredAreaParam, TDesiredCare, TDesiredArea,
  TDesiredStoreParam, TDesiredCourse, TDesiredStore, TCourseCode, TPointCourseCode, NeighborhoodStores, TDetailOnlineStoreParam, TDetailOnlineStore,
} from 'pages/reservationBookingOnlineV2/pages/StepsBeforeReservation/types';
import ApiClient from './ApiClient';


// ご希望のお手入れ
export const getDesiredCareApi = async (params: TDesiredCareParam): Promise<TDesiredCare[]> => {
  const { data } = await ApiClient.get('/v1/contractCourseCategories/existingClient/getByClassType', {}, params);
  return data;
};

// ご希望のコース
export const getDesiredCourseApi = async (params: TDesiredCourseParam): Promise<TDesiredCourse[]> => {
  const { data } = await ApiClient.get('/v1/contractCourseMsts/existingClient/getContractCourseMst', {}, params);
  return data;
};

// ご希望のエリア
export const getDesiredAreaApi = async (params: TDesiredAreaParam): Promise<TDesiredArea[]> => {
  const { data } = await ApiClient.get('/v1/areaMasters/existingClient/getAreaOnline', {}, params);
  return data;
};

// ご希望の店舗
export const getDesiredStoreApi = async (params: TDesiredStoreParam): Promise<TDesiredStore[]> => {
  const { data } = await ApiClient.get('/v1/organizations/existingClient/getOrganizationOnline', {}, params);
  return data;
};

export const getDetailOnlineStoreApi = async (params: TDetailOnlineStoreParam): Promise<TDetailOnlineStore> => {
  const { data } = await ApiClient.get('/v1/organization/existingClient/getOrganizationDetailOnline', {}, params);
  return data;
};


export const getCurrentCourseCodeApi = async (params: TCourseCode): Promise<TPointCourseCode> => {
  const { data } = await ApiClient.get('/v1/contractCourseMsts/existingClient/getContractCourseMstByCourseCode', {}, params);
  return data;
};


export const getNeighborhoodStoresApi = async (params: { companyCode:string, choosingOrgId: string, contractCourseMstId: string}): Promise<NeighborhoodStores[]> => {
  const { data } = await ApiClient.get('/v1/organizations/bookingOnline/getNeighborhoodStores', {}, params);
  return data;
};

//
export const getAvailableReservationForExistingClientsBookingOnlineApi = async (params: IReservationSearchBookingOnline): Promise<IAvailableReservationBooking[]> => {
  const { data } = await ApiClient.get('/v1/reservations/bookingOnline/availableReservationForExistingClients', params);
  return data;
};


export const getHeadQuarterApi = async (companyCode:string): Promise<IHeadQuarterData> => {
  const { data } = await ApiClient.get(`/v1/reservationHeadquartersSettings/${companyCode}`, {});
  return data;
};

export const getStoreSettingDetailApi = async (params: { orgId: string, companyCode: string}): Promise<IStoreSettingDetail> => {
  const { data } = await ApiClient.get('/v1/reservation/storeSetting', params);
  return data;
};

export const getCMInfoApi = async (companyCode:string): Promise<ICMInfo[]> => {
  const { data } = await ApiClient.get('/v1/reservationCmInfo', { companyCode });
  return data;
};


export const postOnlineReservationsOldCustomer = async (params: IBookingOnlineOldCustomer, mediaCode?:string): Promise<any> => {
  if (!mediaCode) {
    const { data } = await ApiClient.postJsonData('/v1/onlineReservations/oldCustomer', {}, params);
    return data;
  }
  const { data } = await ApiClient.postJsonData('/v1/onlineReservations/oldCustomer', { mediaCode }, params);
  return data;
};


export const sentMailReservationV2Api = async (params:{reservationId:string, companyCode: string, customerType: string}) => {
  const { data } = await ApiClient.postJsonData('/v1/onlineReservations/sendMail', {}, params);
  return data;
};
